export default __webpack_public_path__ + "static/media/logo_iate_versao_12_azul.0d5b471f.jpg";